import React from 'react';

const AgencyCardPlaceholder = () => {
  return (
    <div className="placeholder-ac color-white">
      <div className="placeholder-row placeholder-ac__logo animation" />
      <div className="placeholder-row placeholder-row--mt--10 placeholder-ac__title animation" />
      <div className="placeholder-row placeholder-row--mt--10 placeholder-ac__counts animation" />
      <div className="placeholder-row placeholder-row--mt--10 placeholder-ac__descr animation" />
      <div className="placeholder-row placeholder-row--mt--10 placeholder-ac__descr animation" />
      <div className="placeholder-row placeholder-row--mt--10 placeholder-ac__descr animation" />
    </div>
  );
};

export default AgencyCardPlaceholder;
